import { Box, Menu, Text } from "@mantine/core"
import {
  CastDto,
  PersonStatusDto,
  WithPermissions,
} from "../../../../../../@client/Theasoft_ApiServer_Orchestra"
import { SimpleShiftType } from "../../../../../../@client/Theasoft_ApiServer_ShiftTypes"
import css from "./cast-dropdown.module.css"
import { useTranslation } from "react-i18next"

export function CastCellDropdown({
  availableAbsenceShiftTypes,
  casts,
  onCastSelected,
  allowAdd,
  onAddClicked,
  allowAddAbsence,
  onAddAbsenceClicked,
  onEditAbsenceClicked,
  personStatuses,
  onQuickDelete,
  allowDelete,
  workareaId,
  ...props
}: {
  allowDelete: boolean
  personStatuses: WithPermissions<PersonStatusDto>[]
  availableAbsenceShiftTypes: SimpleShiftType[]
  allowAddAbsence: boolean
  allowAdd: boolean
  onAddAbsenceClicked: (shiftTypeId: number) => void
  onEditAbsenceClicked: (personStatus: PersonStatusDto) => void
  onAddClicked: () => void
  onCastSelected: (cast: CastDto) => void
  onQuickDelete: ({
    castId,
    contractId,
    activityId,
    workareaId,
  }: {
    castId: number
    contractId: number | null
    activityId: number
    workareaId?: number
  }) => void
  casts: CastDto[]
  workareaId?: number
}) {
  const { t } = useTranslation()
  if (casts === undefined) return null
  const castItems = casts.map((v, i) => (
    <>
      <Menu.Item
        className={css["highlight-menu-item"]}
        key={i}
        onClick={() => {
          onCastSelected(v)
        }}
      >
        <Text span td={v.isCanceled ? "line-through" : undefined}>
          {t("EditCastRoleX", { role: v.roleName })}
        </Text>{" "}
        <Text span>{v.isCanceled ? ` (${t("Canceled_lower")}) ` : null}</Text>
        {v.note && v.note !== "" ? (
          <Box>
            <Text size="xs" c="yellow">
              "{v.note}"
            </Text>
          </Box>
        ) : null}
      </Menu.Item>
      {allowDelete ? (
        <Menu.Item
          className={css["highlight-menu-item"]}
          key={`delete-${i}`}
          onClick={() => {
            onQuickDelete({
              castId: v.castId,
              contractId: v.contractId,
              activityId: v.activityId,
              workareaId: workareaId,
            })
          }}
        >
          <Text span td={v.isCanceled ? "line-through" : undefined}>
            {t("DeleteCastRoleX", { role: v.roleName })}
          </Text>{" "}
          <Text span>{v.isCanceled ? ` (${t("Canceled_lower")}) ` : null}</Text>
        </Menu.Item>
      ) : null}
    </>
  ))

  const absenceItems = personStatuses.map((v, i) => (
    <>
      {i === 0 && casts.length > 0 ? <Menu.Divider key="divider1" /> : null}
      <Menu.Item
        className={css["highlight-menu-item"]}
        key={"personstatus-" + i}
        disabled={v.permission === "ReadOnly"}
        onClick={() => onEditAbsenceClicked(v.value)}
      >
        <Text>{v.value.statusDisplayName}</Text>
      </Menu.Item>
    </>
  ))
  const castActions = allowAdd ? (
    <>
      <Menu.Divider key="divider2" />
      <Menu.Item key="additional" onClick={onAddClicked}>
        <Text>
          {casts.length > 0
            ? t("CastAdditonalInstrument")
            : t("CastInstrument")}
        </Text>
      </Menu.Item>
    </>
  ) : null
  const absenceActions = allowAddAbsence ? (
    <>
      {availableAbsenceShiftTypes.map((v, i) => (
        <>
          {i === 0 && casts.length > 0 && personStatuses.length > 0 ? (
            <Menu.Divider key="divider3" />
          ) : null}
          <Menu.Item
            key={"absence-" + i}
            onClick={() => onAddAbsenceClicked(v.shiftTypeId)}
          >
            <Text>
              {t("EnterAbsenceX", {
                name: v.name,
                interpolation: { escapeValue: false },
              })}
              {v.shortName ? ` (${v.shortName})` : ""}
            </Text>
          </Menu.Item>
        </>
      ))}
    </>
  ) : null
  if (
    castItems.length === 0 &&
    absenceItems.length === 0 &&
    castActions === null &&
    absenceActions === null
  ) {
    return null
  }
  return (
    <Menu.Dropdown {...props}>
      {castItems}
      {absenceItems}
      {castActions}
      {absenceActions}
    </Menu.Dropdown>
  )
}
